import {AntibodyEnforcedSchemaSpec} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';

export default function hasEnforcedDataModelChanges(enforcedSchemaSpec: AntibodyEnforcedSchemaSpec): boolean {
  return (
    enforcedSchemaSpec.enforcedFieldSpecs.length > 0 || enforcedSchemaSpec.enforcedConstraintSpec != null
  );
}
